import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { VideoLanguages } from '../language/language';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss'],
    standalone: false
})
export class LanguageSelectorComponent implements OnInit {

  languages: { id: number; description: string }[] = []

  constructor(private _langservice:LanguageService,private dialogRef: MatDialogRef<LanguageSelectorComponent>) { }

  ngOnInit(): void {
    this._langservice.getAllVideoLanguages().subscribe({
      next: (data) => {
        const normalized = this.normalizeLanguageList(data);
        this.languages = normalized.length ? normalized : this._langservice.getFallbackVideoLanguages();
      },
      error: () => {
        this.languages = this._langservice.getFallbackVideoLanguages();
      }
    });
  }

  private normalizeLanguageList(data: unknown): { id: number; description: string }[] {
    if (!Array.isArray(data)) {
      return [];
    }
    return data
      .map((item: any) => ({
        id: Number(item?.id ?? item?.Id),
        description: String(item?.description ?? item?.Description ?? '').trim(),
      }))
      .filter((row) => !Number.isNaN(row.id) && row.description.length > 0);
  }

  setLanguage(language:VideoLanguages)
  {
    this._langservice.setCurrentLang(language.toString())
    this.dialogRef.close()
  }

}
